export default "__VITE_ASSET__Bkxc$6JN__"